module Meevo.Plugins.MembershipManager {
    "use strict";

    /**
     * Section
     */

    interface IElevatedACHInfo {
        number: string;
        paymentAccountId: string;
        numberType: string;
    }


    export class CCSection extends MembershipBaseSection {
        public businessSettingsMembership: any;
        public selectedCreditCardTerminal: any;
        public creditCardTerminals: Array<any>;
        public merchantAccounts: Array<Meevo.Model.MerchantAccount>;
        public selectedMerchantAccount: Meevo.Model.MerchantAccount;
        public isHostedPageEnabled: boolean = false;
        public isHostedPageAllowed: boolean = true;
        public merchantAccountId: any;
        public sectionEndpoint = 'cc';
        public hasHsaFsaMerchantAccount = false;

        public loadDependentData(): ng.IPromise<any> {
            this.params.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys.REGISTER_REGISTER_ACTION_HOSTEDPAGE).then(result => {
                this.isHostedPageAllowed = result !== Model.SecurityAccessEnum.Hide;
            });

            return this.params.$q.all([this.getBusinessSettingsMembership(), this.getMerchantInfo()])
                .then(() => {
                    this.selectDefaultTerminals();
                    // Go to main tab
                    if (this.params['context'].redirectedFromMain) {
                        this.params['context'].redirectedFromMain = false;
                        this.params['context'].selectSection(this.params['context'].sections[0]);
                    }
                    // Go from main tab
                    if (this.params['context'].autoRenewSettings && this.params['context'].autoRenewSettings.autoRenewEnabled === true && this.model.paymentAccounts.length === 0) {
                        this.params['context'].setMode(Meevo.Model.MaintenanceFormState.Readonly);
                        this.params['context'].edit();
                        this.params['context'].redirectedFromMain = true;
                    }
                });
        }

        getBusinessSettingsMembership(): ng.IPromise<any> {
            return this.dataService.customMethodData(`${this.appSettings.API_ROOT}/Settings/membership`, 'GET', null).then((response) => {
                if (response && response.data) {
                    return this.businessSettingsMembership = response.data;
                }
            });
        }

        getMerchantInfo(): ng.IPromise<Array<Meevo.Model.MerchantAccount>> {
            let request: any = {
                pageNumber: 0,
                itemsPerPage: 1000,
                criteria: {
                    isActiveOnly: true
                }
            };

            return this.dataService.getListPaged("merchantaccount", request)
                .then((merchantAccounts: Array<Meevo.Model.MerchantAccount>) => {
                    if (merchantAccounts) {
                        return this.merchantAccounts = merchantAccounts;
                    }
                });
        }

        selectDefaultTerminals(): void {
            let merchantAccount;
            if (this.businessSettingsMembership && this.businessSettingsMembership.defaultMerchantAccount) {
                merchantAccount = _.find(this.merchantAccounts, (el) => el.id === this.businessSettingsMembership.defaultMerchantAccount);
            }

            if (!merchantAccount) {
                merchantAccount = _.find(this.merchantAccounts,(el) => el.isDefault === true);
            }

            this.hasHsaFsaMerchantAccount = !!this.merchantAccounts.find(candidateMerchantAccount => 
                candidateMerchantAccount.isHsaFsa);

            if (this.identityService.inCentralOfficeMode()) {
                this.params.modalService.alert('MESSAGE_MEMBERSHIP_CC_ACH_AT_CO');
                return;
            }

            if (merchantAccount) {
                this.isHostedPageEnabled = merchantAccount.isHostedPageEnabled;
                
                // Get data for selectedMerchantAccount
                this.getMerchantAccount(merchantAccount.id);
                this.merchantAccountId = merchantAccount.id;

                // Get Terminals
                this.getTerminalsList(merchantAccount);

            } else if (!this.params['context'].isReload) {
                this.params.modalService.alert('LABEL_DEFAULT_MERCHANT_ACCOUNT_IS_NOT_SET');
            }
        }

        getTerminalsList(merchantAccount) {
            const request = {
                criteria: {
                    isActiveOnly: true,
                    isHostedMode: this.isHostedPageAllowed,
                }
            };

            const endPointUrl = `${this.appSettings.API_ROOT}/${this.appSettings.API_ENDPOINTS.merchantAccount}/${merchantAccount.id}/Devices/List`;

            this.dataService.customMethodData(endPointUrl, "POST", request).then((res: any) => {

                if (res.data && res.data.length > 0) {

                    this.creditCardTerminals = _(res.data)
                        .map((terminal: any) => {
                            if (terminal.merchantTerminalType === Meevo.Model.MerchantTerminalTypeEnum.Hosted) {
                                if (merchantAccount.merchantProviderId === Meevo.Model.MerchantAccountProviderEnum.CardConnect) {
                                    terminal.displayName = this.params.$translate.instant('LABEL_CARD_CONNECT_HOSTED_PAGE');
                                } else {
                                    terminal.displayName = this.params.$translate.instant('LABEL_HOSTED_PAGE');
                                }
                            }
                            return terminal;
                        });

                    this.selectedCreditCardTerminal = this.creditCardTerminals[0];
                    
                    this.merchantAccountId = this.selectedCreditCardTerminal.merchantAccountId;

                } else if (this.model['clientMembershipPaymentAccounts'].length>0 && this.model['clientMembershipPaymentAccounts'][0].paymentAccountType === Meevo.Model.PaymentAccountTypeEnum.Card) {
                    this.params.modalService.alert('ERROR_HTTP_403_NO_TERMINALS_FOUND');
                }
                
            });
        }

        getMerchantAccount(merchantAccountId): ng.IPromise<any> {
            return this.dataService.getItem(`merchantAccount`, merchantAccountId)
                .then((data: any) => {
                    if (data) {
                        return this.selectedMerchantAccount = data;
                    }
                })
                .catch(() => {
                    return false;
                });
        }

        getMerchantAccountDirectManualEntry() {
            return (this.selectedMerchantAccount && this.selectedMerchantAccount.directManualEntry);
        }

        canSelectedMerchantAccountCreateToken(): boolean {
            return this.selectedMerchantAccount && this.selectedMerchantAccount.canCreateTokens;
        }

        addPaymentAccount(): void {
            if (this.hasOwnProperty('selectedCreditCardTerminal')) {
                let paymentAccountTemplate = {
                    paymentAccountType: Meevo.Model.PaymentAccountTypeEnum.Card,
                    merchantAccountId: this.selectedCreditCardTerminal.merchantAccountId
                };

                this.model.paymentAccounts.push(paymentAccountTemplate);
            }
        }

        changeSelectedCreditCardTerminal() {
            // Change selectedMerchantAccount
            // Now available default merchantAccount only
        }

        isHomeLocation(): boolean {
            return this.model.homeLocationId == this.identityService.current().locationId;
        }

        validateCanEdit(): boolean {
            return this.model.clientMembershipStatusEnum !== Model.ClientMembershipStatusEnum.Cancelled;
        }

        elevationChallenge(options: IElevatedACHInfo) {
            this.params.securityChecker.checkSecurityItem(Meevo.Components.Common.SecurityKeys.MEMBERSHIP_MEMBERSHIPMANAGER_TAB_CCACH_VIEWACHINFORMATION).then((item: Model.SecurityItem) => {
                if (item.securityAccess == Model.SecurityAccessEnum.Grant || !options.number || !options.number.includes('*')) {
                    return;
                }
                else if (item.securityAccess == Model.SecurityAccessEnum.Deny && item.canElevate) {
                    let defer = this.params.$q.defer();
                    defer.promise.then(() => {
                        this.dataService.customMethodData(`${this.appSettings.API_ROOT}/membership/client/${this.model.id}`, 'GET', null)
                            .then((res) => {
                                this.model = res.data;
                            })
                    }).catch(() => {
                        if (!this.params['context'].isReadonly) {
                            let index = this.model.paymentAccounts.findIndex(item => item.id === options.paymentAccountId);
                            this.model.paymentAccounts[index][options.numberType] = '';
                        }
                    });
                    this.params.$rootScope.$broadcast(Meevo.Components.Common.Messages.ELEVATION_CHALLENGE, defer, item.key.replace(/:/gi, '_'), item.displayName, this.identityService.current().userName, item.securityKeyPath);
                } else {
                    this.params.modalService.alert('MESSAGE_NO_ACCESS_MEMBERSHIP_MANAGER_VIEW_ACH_INFO', Components.Modal.ModalTranslationModes.Translate)
                        .then(() => {
                            if (!this.params['context'].isReadonly) {
                                let index = this.model.paymentAccounts.findIndex(item => item.id === options.paymentAccountId);
                                this.model.paymentAccounts[index][options.numberType] = '';
                            }
                        });
                }
            });
            
        }

        rollbackChanges() {
            var paymentAccountQueuedValues = angular.copy(this.model.paymentAccounts
                .filter(paymentAccount => paymentAccount.paymentAccountType === Model.PaymentAccountTypeEnum.Card)
                .map(paymentAccount => {return { id: paymentAccount.id, isQueuedForAutoUpdate: paymentAccount.isQueuedForAutoUpdate};}));

            super.rollbackChanges();

            this.model.paymentAccounts
                .filter(paymentAccount => paymentAccount.paymentAccountType === Model.PaymentAccountTypeEnum.Card)
                .forEach(paymentAccount => paymentAccount.isQueuedForAutoUpdate = _(paymentAccountQueuedValues)
                    .findWhere({id: paymentAccount.id }).isQueuedForAutoUpdate)
        }

        public get auditNoun(): Meevo.Model.NounEnum {
            return Meevo.Model.NounEnum.MembershipPaymentAccount;
        }
    }
}